import React from "react";
import PropTypes from 'prop-types';

const FormElement = ({label, forId, children}) => (
  <div className="form-element">
    <label htmlFor={forId}>{label}</label>
    <div>{children}</div>
  </div>
);

FormElement.propTypes = {
  label: PropTypes.string,
  forId: PropTypes.string,
  children: PropTypes.element,
};

export default FormElement;
